import React, {useState, useEffect, useLayoutEffect} from 'react';
import './ret.css';
import { useLocation, useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { isMobile } from 'react-device-detect';

const Toon =()=>{
    const {way : jikap} = useParams();
    const neyong = useLocation();
    const [pac, setpac] = useState();
    const [momo, setmomo] = useState(neyong.state);
 

    useLayoutEffect(()=>{
        const fetch = async()=>{
            const hoakin = await axios.get(`/api/titi?single=${jikap}`).then(kip=>{setpac(kip.data)})
            .catch(err=>console.log("페이지네이션 오류"));
        };
        fetch(); 
     
        window.scrollTo(0,0);
     
    },[jikap]);

    useEffect(()=>{
        document.title = momo?.title + " - 돌파공모";
    },[momo]);

    useEffect(()=>{
        const fetca = async()=>{
            const kakad = await axios.get(`/api/tonja?single=${jikap}`).then(kp =>{setmomo(kp.data); }).catch(err=>{
                if(err.response?.data?.success === "false"){
                    alert("요청 페이지를 찾을 수 없어요");
                };
            });
        };
        const fetka = async()=>{
            const forty = await axios.get(`/api/tonjone?single=${jikap}`).then(kp =>{setmomo({...momo, hit : momo.hit+1});}).catch(err=>{
                if(err.response?.data?.success === "false"){
                    alert("요청 페이지를 찾을 수 없어요");
                };
            });
        };
        
        if(neyong.state ==  null ||'undy'){
            fetca();
           
        }else{
            fetka();
        
        };
        document.title = momo?.title + " - 돌파공모";
    },[jikap]);

    return(
        <>
        <div className={isMobile ? 'ssoom' : 'smodda'}>
        <p className='modda submod'>{momo?.title}</p>    
        <div className='munjin'><img src={process.env.PUBLIC_URL+`/inda/${momo?.img}`} /></div>   
        <p className={isMobile ? 'mabisi' : 'sabisi'}>관련사항</p>
       
        <div className='sorok sokak' dangerouslySetInnerHTML={{__html:momo?.content}}></div>
        </div>

        <Link to="/mika" onClick={()=>window.history.replaceState({page : window.history.state.page},null,null)} className='haolei saole'><span className='morok'>목록</span></Link>
        {pac?.has !== null && <div className={isMobile ? 'svous' : 'vous'}><span className='vous2'>이전글</span><span className='vous3'><Link to={`/mika/${pac?.has}`} state="undy" className='haolei'>{pac?.hus}</Link></span></div>}
        {pac?.las !== null && <div className={isMobile ? 'svous' : 'vous'}><span className='vous2'>다음글</span><span className='vous3'><Link to={`/mika/${pac?.las}`} state="undy" className='haolei'>{pac?.lus}</Link></span></div>} 
        </>
    )

}

export default Toon;